<template>
  <div class="card kpi-card h-100" :class="`kpi-${colorTheme}`">
    <div class="card-body position-relative">
      <div class="kpi-icon-bg" v-if="icon">
        <i :class="icon"></i>
      </div>
      <div class="kpi-content d-flex flex-column">
        <h6 class="card-title text-uppercase mb-1">{{ label }}</h6>
        <h3 class="card-text font-weight-bold mb-2">{{ value }}</h3>
        <div class="kpi-trend" v-if="trend !== null">
          <!-- <i :class="trendIcon" class="mr-1"></i> -->
          <!-- <span>{{ trend }}%</span> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KpiCard',
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    },
    icon: {
      type: String,
      default: null
    },
    trend: {
      type: Number,
      default: null
    },
    colorTheme: {
      type: String,
      default: 'primary',
      validator: value => ['primary', 'success', 'info', 'warning', 'danger'].includes(value)
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    trendIcon() {
      if (this.trend === null) return '';
      return this.trend > 0 
        ? 'fas fa-arrow-up text-success' 
        : this.trend < 0 
          ? 'fas fa-arrow-down text-danger' 
          : 'fas fa-equals text-muted';
    }
  }
}
</script>

<style scoped>
.kpi-card {
  transition: all 0.3s ease;
  border-radius: 12px;
  border: none;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.kpi-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.kpi-content {
  position: relative;
  z-index: 2;
}

.kpi-icon-bg {
  position: absolute;
  top: -15px;
  right: -15px;
  width: 90px;
  height: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0.15;
  z-index: 1;
}

.kpi-icon-bg i {
  font-size: 3rem;
}

.kpi-trend {
  display: inline-flex;
  align-items: center;
  font-size: 0.85rem;
  font-weight: 600;
}

.card-title {
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: rgba(0, 0, 0, 0.6);
}

.card-text {
  font-size: 1.8rem;
}

/* Themes de couleurs */
.kpi-primary {
  background: linear-gradient(135deg, #4e73df 0%, #3a54c4 100%);
  color: white;
}

.kpi-success {
  background: linear-gradient(135deg, #1cc88a 0%, #13a673 100%);
  color: white;
}

.kpi-info {
  background: linear-gradient(135deg, #36b9cc 0%, #258391 100%);
  color: white;
}

.kpi-warning {
  background: linear-gradient(135deg, #f6c23e 0%, #dfa408 100%);
  color: white;
}

.kpi-danger {
  background: linear-gradient(135deg, #e74a3b 0%, #c72c1c 100%);
  color: white;
}

.kpi-primary .card-title, 
.kpi-success .card-title,
.kpi-info .card-title,
.kpi-warning .card-title,
.kpi-danger .card-title {
  color: rgba(255, 255, 255, 0.8);
}
</style>
